import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class NFOLiveUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getNFOLive();
    }
}
export default NFOLiveUseCase;
